'use client';

import { useCallback } from 'react';

import { useTranslations } from 'next-intl';

import { useCommentsContext } from '@/components/Contexts/CommentsContext';
import { useWorkbenchConfig } from '@/components/Contexts/WorkbenchConfigContext';
import { showErrorToast } from '@/components/ui/ToastNotification';
import { useApiClient } from '@/hooks/useApiClient';

export function useReopenComment() {
  const t = useTranslations();
  const apiClient = useApiClient();
  // Carries feedbackId, metaSiteId and isOwner (false: the commenter reopens
  // their own comment).
  const { sealedContext } = useWorkbenchConfig();
  const {
    state: { pins },
    dispatch,
  } = useCommentsContext();

  const reopenComment = useCallback(
    async (pinId: string) => {
      const pin = pins.find((p) => p.id === pinId);
      if (!pin?.commentId) return;

      try {
        const result = await apiClient
          .post<{ commentId: string; revision: string | null }>(
            'api/reopen-comment',
            {
              ctx: sealedContext,
              commentId: pin.commentId,
              revision: pin.revision,
            },
          )
          .then((r) => r.data);

        dispatch({
          type: 'UPDATE_PIN_STATUS',
          payload: { id: pinId, status: 'NEW', revision: result.revision },
        });
      } catch {
        showErrorToast(t('get-feedback-toast-reopenCommentFailed'));
      }
    },
    [apiClient, pins, sealedContext, dispatch, t],
  );

  return { reopenComment };
}
